import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { CanalRol } from '../_models/canal-rol';
@Injectable({
  providedIn: 'root'
})
export class CanalRolService {

  private rutServicioCanalRol = AppSettings.rutServiciosAPL + '/api/canalesRoles';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listadoCanalesRoles() {
    return this.httClient.get( this.rutServicioCanalRol ).pipe( map( res => res as CanalRol[] ) );
  }

  listadoCanalesRolesHabilitados() {
    return this.httClient.get( this.rutServicioCanalRol + '/enabled' ).pipe( map( res => res as CanalRol[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicioCanalRol + '/' + id ).pipe( map( res => res as CanalRol ) );
  }

  obtenerPorIdCanal( id: string ) {
    return this.httClient.get( this.rutServicioCanalRol + '/canales/' + id ).pipe( map( res => res as CanalRol[] ) );
  }

  crear( canalRol: CanalRol ) {
    canalRol.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicioCanalRol, canalRol ).pipe( map( res => res as CanalRol ) );
  }

  actualizar( canalRol: CanalRol ) {
    canalRol.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicioCanalRol, canalRol ).pipe( map( res => res as any ) );
  }


}
